// ** React Imports
import { useMemo } from "react";
import { useParams } from "react-router-dom";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useQuery from "hooks/useQuery";

// ** Custom Filters
import { compute as filterPreferencesCompute } from "hooks/filters/useFilterPreferences";

// #####################################################

const usePreferencesFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	// ** Odczytanie parametrów z adresu URL
	const params = useParams();
	const { preference: preferenceUrl } = params || {};

	const query = useQuery();
	const { preferences: preferenceQueryUrl } = query || {};

	const selectedPreferenceKey = useMemo(() => {
		return preferenceUrl
			? filterPreferencesCompute.urlToValue(preferenceUrl)
			: preferenceQueryUrl
			? filterPreferencesCompute.queryUrlToValue(preferenceQueryUrl)
			: "";
	}, [preferenceUrl, preferenceQueryUrl, language]);

	// ** Filtr - Preferencje
	const preferencesFilterData = useMemo(() => {
		return preferenceUrl || preferenceQueryUrl
			? {
					label: t("filtersAndSelectors:preferencesLabel"),
					selected: t(
						`filtersAndSelectors:preferences.${selectedPreferenceKey}`
					),
			  }
			: null;
	}, [selectedPreferenceKey, language]);

	// #####################################################

	return preferencesFilterData;
};

// #####################################################

export default usePreferencesFilterData;

// #####################################################
